module.exports = __webpack_public_path__ + "static/img/login-logo.d22d63e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-logo.svg
// module id = eb7d
// module chunks = 1